<template>
    <div>
        <el-row class="bottom20">
            <el-table :data="page.records" :row-class-name="getVisitedRowClassName" :cell-class-name="getSelectedCellClassName">
                <el-table-column prop="name">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">公司名称</span><br/>
                        <el-input size="mini" v-model="pageSearch.search.like_name" placeholder="公司名称" />
                    </template>
                    <template slot-scope="scope">
                    <span>
                        <a href="javascript:void(0);" @click="toDetailShow(scope.row)">{{scope.row.name}}</a>
                    </span>
                    </template>
                </el-table-column>

                <el-table-column prop="parentId">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">上级公司</span><br/>
                        <dictionary-select v-model="pageSearch.search.eq_parentId" :default-first-by-only-one="false"
                                           :factory-name="'org_company'" :params="{type: 'ALL'}"
                                           :clearable="true" :filterable="true" size="mini">
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <dictionary-text :factory-name="'org_company'" :params="{type: 'ALL'}" :value="scope.row.parentId">
                        </dictionary-text>
                    </template>
                </el-table-column>

                <el-table-column prop="corporation">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">是否总公司</span><br/>
                        <dictionary-select v-model="pageSearch.search.eq_corporation"
                                           :factory-name="'domain'" :params="'YNTYPE'"
                                           :clearable="true" size="mini">
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <dictionary-text :factory-name="'domain'" :params="'YNTYPE'" :value="scope.row.corporation">
                        </dictionary-text>
                    </template>
                </el-table-column>

                <el-table-column prop="code">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">公司编号</span><br/>
                        <el-input size="mini" v-model="pageSearch.search.like_code" placeholder="公司编号" />
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.code}}</span>
                    </template>
                </el-table-column>

                <el-table-column prop="status">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">状态</span><br/>
                        <dictionary-select v-model="pageSearch.search.eq_status"
                                           :factory-name="'domain'" :params="'COMPANYSTATUS'"
                                           :clearable="true" size="mini">
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <el-tag :type="String(scope.row.status) === '1' ? 'success' : 'danger'">
                            <dictionary-text :factory-name="'domain'" :params="'COMPANYSTATUS'" :value="scope.row.status">
                            </dictionary-text>
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="leaderName">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">公司负责人</span><br/>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.leader != null ? scope.row.leader.name : ''}}
                    </template>
                </el-table-column>

                <el-table-column prop="corporateName">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">公司法人</span><br/>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.corporate != null ? scope.row.corporate.name : ''}}
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination
                    @current-change="setPageSearchCurrent"
                    @size-change="setPageSearchSize"
                    :current-page="pageSearch.current"
                    :page-sizes="[10, 25, 50, 100]"
                    :page-size="pageSearch.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {merge} from '@/util'
    import OrganizationServer from  '@/api/organization'

    import DictionarySelect from '@/components/common/DictionarySelect'
    import DictionaryText from '@/components/common/DictionaryText'

    export default {
        name: 'CompanyChildrenList',
        components: {DictionarySelect, DictionaryText},
        props: {
            search: {},
        },
        data() {
            return {
                idKey: 'id',
                currentRowId: null,
                visitedIds: [],

                pageSearch: {
                    current: 1,
                    size: 10,
                    search: {
                        like_code: null,
                        like_name: null,
                        eq_corporation: null,
                        eq_parentId: null,
                        eq_status: '1',
                    },
                },
                page: {
                    total: 0,
                    records: []
                },
            };
        },
        computed: {
            readable() {
                return true;
            },
            modifiable() {
                return true;
            },
            deletable() {
                return true;
            },
        },
        watch: {
            'search': {
                deep: false,
                immediate: true,
                handler() {
                    let search = this.search;
                    if (search != null) {
                        let pageSearch = JSON.parse(JSON.stringify(this.pageSearch));
                        pageSearch.search = merge(true, pageSearch.search, search);
                        this['setPageSearch'](pageSearch);
                    }
                },
            },
            'pageSearch.current': {
                deep: false,
                immediate: false,
                handler() {
                    this.queryByPage();
                },
            },
            'pageSearch.size': {
                deep: false,
                immediate: false,
                handler() {
                    this.reQueryByPage();
                },
            },
            'pageSearch.search': {
                deep: true,
                immediate: false,
                handler(search) {
                    this.reQueryByPage();
                    if (search != null) {
                        //
                    }
                }
            },
            'page': {
                deep: true,
                immediate: false,
                handler(page) {
                    this['setPage'](page);
                    if (page.total > 0) {
                        let record;
                        let records = page.records;
                        let currentRowId = this['currentRowId'];
                        if (currentRowId != null) {
                            for (let i = 0, l = records.length; i < l; i++) {
                                if (currentRowId === records[i][this.idKey]) {
                                    record = records[i];
                                    break;
                                }
                            }
                        }
                        if (record == null) {
                            record = records[0];
                        }
                        this.select(record);
                    }
                },
            },
        },
        methods: {
            setCurrentRowId(currentRowId) {
                this.currentRowId = currentRowId;
            },
            addVisitedId(currentRowId) {
                if (currentRowId != null) {
                    let visitedIds = this.visitedIds;
                    let existed = false;
                    for (let i = 0, len = visitedIds.length; i < len; i++) {
                        if (visitedIds[i] === currentRowId) {
                            existed = true;
                            break;
                        }
                    }
                    if (!existed) {
                        visitedIds.push(currentRowId);
                    }
                }
            },
            removeVisitedId(currentRowId) {
                if (currentRowId != null) {
                    let visitedIds = this.visitedIds;
                    let index = -1;
                    for (let i = 0, len = visitedIds.length; i < len; i++) {
                        if (visitedIds[i] === currentRowId) {
                            index = i;
                            break;
                        }
                    }
                    if (index > -1) {
                        visitedIds.splice(index, 1);
                    }
                }
            },
            setPageSearch(pageSearch) {
                this.pageSearch = pageSearch;
            },
            setPageSearchCurrent(current) {
                this.pageSearch.current = current;
            },
            setPageSearchSize(size) {
                this.pageSearch.size = size;
            },
            setPageSearchSearch(search) {
                this.pageSearch.search = search;
            },
            setPage(page) {
                this.page = page;
            },
            async doQueryByPage(pageSearch) {
                // 查询
                OrganizationServer.company.page(pageSearch).then(res => {
                    if (res.data.code == null || res.data.code === '200') {
                        let records = res.data.data.records;
                        if (records.length === 0 && pageSearch.current > 1) {
                            this.setPageSearchCurrent(pageSearch.current - 1);
                        } else {
                            this.$emit('after-query', res.data.data);
                            this.setPage(res.data.data);
                        }
                    }
                });
            },
            reQueryByPage() {
                if (this.pageSearch.current === 1) {
                    this.queryByPage();
                } else {
                    this['setPageSearchCurrent'](1);
                }
            },
            queryByPage: _.debounce(function() {
                this['doQueryByPage'](JSON.parse(JSON.stringify(this.pageSearch)));
            }) ,
            query() {
                this.queryByPage();
            },
            reQuery() {
                this.reQueryByPage();
            },
            select(data) {
                this['setCurrentRowId'](data.id);
            },
            getSelectedCellClassName({row}) {
                let cellClassName = '';
                if (this['currentRowId'] === row[this.idKey]) {
                    cellClassName += ' currentAccess ';
                }
                return cellClassName;
            },
            getVisitedRowClassName({row}) {
                let rowClassName = '';
                if (this['visitedIds'].indexOf(row[this.idKey]) !== -1) {
                    rowClassName += ' visited';
                }
                return rowClassName;
            },
            toDetailShow(data) {
                this.select(data);
                this['addVisitedId'](data[this.idKey]);
                window.open(window.location.origin + `/organization/company/detail?operation=show&id=${data[this.idKey]}`);
                // this.$router.push({path: '/organization/company/detail', query: {operation: 'show', id: data[this.idKey]}});
            },
            toDetailEdit(data) {
                this.select(data);
                this['addVisitedId'](data[this.idKey]);
                window.open(window.location.origin + `/organization/company/detail?operation=edit&id=${data[this.idKey]}`);
                // this.$router.push({path: '/organization/company/detail', query: {operation: 'edit', id: data[this.idKey]}});
            },
            async toDetailDelete(data) {
                try {
                    let confirmed = await this.$confirm('确定删除吗？', '删除提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    });
                    if (confirmed) {
                        let res = await OrganizationServer.company.delete(data.id);
                        if (res.data.success) {
                            this['removeVisitedId'](data.id);
                            this['setCurrentRowId'](null);
                            this.$message.success('删除成功！');
                            this.query();
                        } else {
                            this.$message.error(`删除失败：${res.data.message}`);
                        }
                    }
                } catch (e) {
                    console.error(e);
                }
            },
        },
        mounted() {
            this.query();
        },
    }
</script>

<style scoped>

</style>
